import { Navigate } from "react-router-dom"
import { ProtectedRouteProps } from "../types"

export function ProtectedRoute({ isAuthenticated, outlet, redirectTo }: ProtectedRouteProps) {
  if (isAuthenticated) return outlet
  else return <Navigate to={redirectTo} />
}
